import { render, staticRenderFns } from "./PaySdk.vue?vue&type=template&id=d49af436&scoped=true"
import script from "./PaySdk.vue?vue&type=script&lang=js"
export * from "./PaySdk.vue?vue&type=script&lang=js"
import style0 from "./PaySdk.vue?vue&type=style&index=0&id=d49af436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49af436",
  null
  
)

export default component.exports